import React from "react";
import { Link } from "react-router-dom";

const ErrorPage = () => (
  <section className="notfound">
    <div>
      <h1>404</h1>
      <h2>
        This page <span className="ink-italic">doesn't exist.</span>
      </h2>
      <p>The link may be broken, or the post may have been removed.</p>
      <Link to="/" className="btn btn--primary">
        Back to BrainBytes
      </Link>
    </div>
  </section>
);

export default ErrorPage;
